import Cookies from "js-cookie";
import env from "@/env";
import { decrypt } from "@/utils/functions";

const TOKEN_KEY = "sys_token";
const USUARIO = "sys_usuario";
const OPCIONES = "sys_opciones";
const expires = env("VUE_APP_EXP_COOKIE") || 30; // expresed in days

export const getToken = () => {
  return Cookies.get(TOKEN_KEY);
};

export const setToken = (token) => {
  return Cookies.set(TOKEN_KEY, token, { expires: parseInt(expires) });
};

export const removeToken = () => {
  return Cookies.remove(TOKEN_KEY);
};

export const setUsuario = (usuario) => {
  return localStorage.setItem(USUARIO, JSON.stringify(usuario));
};

export const setOpciones = (opciones) => {
  return localStorage.setItem(OPCIONES, JSON.stringify(opciones));
};

export const getUsuario = () => {
  return (Cookies.get(TOKEN_KEY) && JSON.parse(localStorage.getItem(USUARIO))) || null;
};

export const getOpcion = (opcion) => {

  var body = JSON.parse(localStorage.getItem(OPCIONES)) || null;

  var opciones = JSON.parse(decrypt(body));
  var arrayOpcion = JSON.parse(opciones);
  var filter = arrayOpcion.filter(item => item.opcion == opcion);

  return (filter[0] != null)? filter[0].accion.split(",") : [];
};

export const removeUsuario = () => {
  return localStorage.removeItem(USUARIO);
};

export const removeOpciones = () => {
  return localStorage.removeItem(OPCIONES);
};

export const removeAllTokens = () => {
  removeToken();
  removeUsuario();
  removeOpciones();
  return "tokens deleted successfully";
};

export class MyError extends Error {
  constructor(status, ...params) {
    // Needs to pass both `message` and `options` to install the "cause" property.
    super(...params);

    this.status = status;
  }
}
